export default {
      id: "color_biome_quality-usage",
      viewBox: "0 0 47 47",
      url: __webpack_public_path__ + "sprite.svg#color_biome_quality",
      toString: function () {
        return this.url;
      }
    }